/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxConfigResponse } from './LootBoxConfigResponse';
import {
    LootBoxConfigResponseFromJSON,
    LootBoxConfigResponseFromJSONTyped,
    LootBoxConfigResponseToJSON,
    LootBoxConfigResponseToJSONTyped,
} from './LootBoxConfigResponse';

/**
 * 
 * @export
 * @interface AddLootBoxPrizeResponse
 */
export interface AddLootBoxPrizeResponse {
    /**
     * 
     * @type {LootBoxConfigResponse}
     * @memberof AddLootBoxPrizeResponse
     */
    lootBoxConfig: LootBoxConfigResponse;
}

/**
 * Check if a given object implements the AddLootBoxPrizeResponse interface.
 */
export function instanceOfAddLootBoxPrizeResponse(value: object): value is AddLootBoxPrizeResponse {
    if (!('lootBoxConfig' in value) || value['lootBoxConfig'] === undefined) return false;
    return true;
}

export function AddLootBoxPrizeResponseFromJSON(json: any): AddLootBoxPrizeResponse {
    return AddLootBoxPrizeResponseFromJSONTyped(json, false);
}

export function AddLootBoxPrizeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddLootBoxPrizeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lootBoxConfig': LootBoxConfigResponseFromJSON(json['lootBoxConfig']),
    };
}

export function AddLootBoxPrizeResponseToJSON(json: any): AddLootBoxPrizeResponse {
    return AddLootBoxPrizeResponseToJSONTyped(json, false);
}

export function AddLootBoxPrizeResponseToJSONTyped(value?: AddLootBoxPrizeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lootBoxConfig': LootBoxConfigResponseToJSON(value['lootBoxConfig']),
    };
}

